import React, { useCallback } from "react";
import FilterTag from "components/common/FilterTag";
import { itemTypes } from "./FeedItemTypeFilter";

const ActiveFeedItemTypeFilter = ({ onTypeToggle, type }) => {
  const onRemove = useCallback(() => onTypeToggle(type), [onTypeToggle, type]);

  return <FilterTag label={itemTypes[type].label} onRemove={onRemove} />;
};

export default ActiveFeedItemTypeFilter;
